import { TCreateVideoCategoryVisibleForm, TTypeOfCreateVideoCategoryModalWindow } from './createVideoCategoryContext';
import { IItemForGetShortInfo, TLanguageIDs, ICreateVideoCategory, IVideoCategoryTranslation } from 'types';

export enum CreateVideoCategoryActionTypes {
	CHANGE_VISIBLE_FORM = 'CHANGE_VISIBLE_FORM',
	CHANGE_NAME = 'CHANGE_NAME',
	SET_FETCHED_LANGUAGES = 'SET_FETCHED_LANGUAGES',
	SET_IDs_LANGUAGES = 'SET_IDs_LANGUAGES',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SET_TRANSLATION_TAB = 'SET_TRANSLATION_TAB',
	SET_TRANSLATION_FIELDS = 'SET_TRANSLATION_FIELDS',
	CHANGE_TRANSLATION = 'CHANGE_TRANSLATION',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface IChangeVisibleForm {
	type: CreateVideoCategoryActionTypes.CHANGE_VISIBLE_FORM;
	payload: {
		visibleForm: TCreateVideoCategoryVisibleForm;
	};
}

interface IChangeName {
	type: CreateVideoCategoryActionTypes.CHANGE_NAME;
	payload: {
		name: string;
	};
}

interface ISetFetchedLanguages {
	type: CreateVideoCategoryActionTypes.SET_FETCHED_LANGUAGES;
	payload: {
		languages: IItemForGetShortInfo[];
	};
}

interface ISetIDsLanguages {
	type: CreateVideoCategoryActionTypes.SET_IDs_LANGUAGES;
	payload: {
		IDsLanguages: TLanguageIDs[];
	};
}

interface ISetDataForSubmit {
	type: CreateVideoCategoryActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		data: ICreateVideoCategory | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: CreateVideoCategoryActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfCreateVideoCategoryModalWindow;
	};
}

interface ISetTranslationTab {
	type: CreateVideoCategoryActionTypes.SET_TRANSLATION_TAB;
	payload: {
		translationTab: TLanguageIDs | null;
	};
}

interface ISetTranslationFields {
	type: CreateVideoCategoryActionTypes.SET_TRANSLATION_FIELDS;
	payload: {
		updatedTranslations: IVideoCategoryTranslation[];
	};
}

interface IChangeTranslation {
	type: CreateVideoCategoryActionTypes.CHANGE_TRANSLATION;
	payload: {
		updatedTranslations: IVideoCategoryTranslation[];
	};
}

interface IResetSelectedControls {
	type: CreateVideoCategoryActionTypes.RESET_FIELDS;
}

export type TCreateVideoCategoryAction =
	| IChangeVisibleForm
	| IChangeName
	| ISetFetchedLanguages
	| ISetIDsLanguages
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| ISetTranslationTab
	| ISetTranslationFields
	| IChangeTranslation
	| IResetSelectedControls;
